const RELATED_EVENTS_DISABLED_EVENT_ID_PREFIX = [
  '2025_wa_hengda', // Event name
  '2025_hengda', // Group name
  '2025_wa_cie_sea', // Event name
  '2025_cie_sea', // Group name
  '2026_wa_spring_0208', // Event name
];

export function showRelatedEvents(eventIdOrEventGroupId: string) {
  return !RELATED_EVENTS_DISABLED_EVENT_ID_PREFIX.some((prefix) =>
    eventIdOrEventGroupId.startsWith(prefix),
  );
}
